<template>
  <div data-component-group="filter-forms" data-component="user">
    <FiltersForm
      :has-filters="hasFilters"
      :is-global-country-filter="isInternalUsersPage"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <Can action="see-user-search" subject="filter">
        <v-text-field
          clearable
          v-model="search"
          type="search"
          label="Search"
          prepend-inner-icon="search"
        />
      </Can>

      <v-autocomplete
        clearable
        v-if="!isPendingUsersPage"
        v-model="status"
        :items="statuses"
        prepend-inner-icon="download_done"
        :return-object="true"
        item-title="name"
        label="Status"
        @focus="onFocusStatus"
      />

      <Can action="see-user-role" subject="filter">
        <v-autocomplete
          clearable
          v-model="role"
          :items="roles"
          prepend-inner-icon="supervisor_account"
          :return-object="true"
          item-title="name"
          label="Role"
          @focus="onFocusRoles"
        />
      </Can>
    </FiltersForm>
  </div>
</template>

<script>
import { v1 as uuidv1 } from 'uuid';
import stringEscape from 'js-string-escape';
import FiltersForm from './FiltersBase';
import { isNull, isNum, isStr, isNonEmptyArr, debounce } from '@/utils';

const debouncer = debounce({
  id: uuidv1(),
  timeout: 500
});

// TODO: Translate component

export default {
  components: {
    FiltersForm,
  },
  emits: ['clearFilters', 'filter'],
  data() {
    return {
      search: '',
      role: null,
      roles: [],
      status: null,
      selectedCountries: [],
    };
  },
  computed: {
    hasFilters() {
      const { search, role = {}, status = {} } = this;

      return (
        search !== '' ||
        isStr(role?.slug) ||
        isNum(status?.id) ||
        (isNonEmptyArr(this.selectedCountries) && this.isInternalUsersPage)
      );
    },
    statuses() {
      return this.$store.getters['businessUsers/statuses'];
    },
    isPendingUsersPage() {
      return this.$route.name === 'users-pending';
    },
    isInternalUsersPage() {
      return this.$route.name === 'internal-users';
    },
  },
  methods: {
    getUserStatuses() {
      if (this.statuses.length) {
        return;
      }

      return this.$store.dispatch('businessUsers/getStatuses');
    },
    getUserRoles() {
      const params = {};

      if (this.isInternalUsersPage) {
        params.type = 1;
      } else {
        params.type = 2;
      }

      return this.$store.dispatch('users/getRolesSpecified', params)
        .then(res => {
          this.roles = res
        })
        .catch(err => err);
    },
    onFilter() {
      const { search, role = {}, status = {}, selectedCountries } = this;
      const formattedSearch = isNull(search) ? '' : stringEscape(search);

      const args = {
        search: formattedSearch,
        role: role?.slug,
        status: status?.id,
      };

      if (this.isInternalUsersPage) {
        args.countries = selectedCountries;
      }

      this.$emit('filter', args);
    },
    onClearFilters() {
      this.search = '';
      this.role = null;
      this.status = null;

      this.$emit('clearFilters');
    },
    onFocusStatus() {
      if (this.statuses.length === 0) {
        this.getUserStatuses();
      }
    },
    onFocusRoles() {
      if (this.roles.length === 0) {
        this.getUserRoles();
      }
    },
  },
};
</script>
